import React, { useEffect, useState } from 'react';
import ApplicationLayout from 'v3/layouts/Application';
import InfiniteScroll from 'v3/components/InfiniteScroll';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import { useSnackbar } from 'v3/components/Snackbar';
import useQuery from 'hooks/useQuery';
import Filter from './Filter';
import Card from './Card';
import {
  listBusinessGroups,
  importBusinessGroupsFromBenner,
} from '../Services';

export default function BusinessGroupList() {
  const snackbar = useSnackbar();
  const query = useQuery();

  const [loading, setLoading] = useState(false);
  const [importing, setImporting] = useState(false);
  const [groups, setGroups] = useState([]);
  const [pagination, setPagination] = useState({
    lastPage: 1,
    page: 1,
    total: 0,
    perPage: 20,
  });

  async function load(page = 1) {
    if (page === 1) setLoading(true);
    try {
      const res = await listBusinessGroups({
        page,
        perPage: pagination.perPage,
        q: query.get('q') || undefined,
      });

      setPagination((old) => ({
        ...old,
        page: res.page,
        lastPage: res.lastPage,
        total: res.total,
      }));

      setGroups((old) => (page === 1 ? res.data : [...old, ...res.data]));
    } catch {
      snackbar.show(
        <Text>Não foi possível carregar os grupos</Text>,
        { type: 'error' }
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load(1);
  }, [query.get('q')]);

  async function handleImport() {
    setImporting(true);

    try {
      await importBusinessGroupsFromBenner({
        page: 1,
        perPage: pagination.perPage,
        includePersons: false,
      });

      snackbar.show(
        <Text>
          Importação de grupos empresariais concluída com sucesso
        </Text>,
        { type: 'success' }
      );

      await load(1);
    } catch (e) {
      snackbar.show(
        <Text>Falha ao importar do Benner</Text>,
        { type: 'error' }
      );
    } finally {
      setImporting(false);
    }
  }

  return (
    <ApplicationLayout
      title="Grupos Empresariais"
      RightComponent={
        <Button
          loading={importing}
          variant="secondary"
          className="py-2"
          onClick={handleImport}
        >
          <Text weight={500} color="gray" type="regular">
            Importar do Benner
          </Text>
        </Button>
      }
    >
      <Filter loading={loading} />

      <InfiniteScroll
        loading={loading}
        data={groups}
        renderItem={(g) => <Card group={g} />}
        onEndReach={() => {
          if (!loading && pagination.page < pagination.lastPage) {
            load(pagination.page + 1);
          }
        }}
        hasMore={pagination.page < pagination.lastPage}
        scrollThreshold={0.7}
      />
    </ApplicationLayout>
  );
}
